import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { FormControl, FormGroup, FormBuilder, Validators } from "@angular/forms";
import { BusinesLogicService } from "../../services/business-logic.service";
import { DataService } from "../../services/data.service";
import { LanguageService } from "../../services/language.service";
import { NotificationService } from "../../services/notification.service";
import { Observable, Subscription, Subject } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { ModalHelper } from "../../components/modal/modal.helper";
import { LanguagePipe } from "../../services/language.pipe";
import { takeUntil } from "rxjs/operators";
import { BusinessEventService } from "../../services/business-event.service";
import { DeskConfig } from "../../models/deskconfig.model";

declare var $: any;
declare var jQuery: any;

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  @Output() logged = new EventEmitter();
  @Input() visible = true;

  loginForm: FormGroup;
  hasError: boolean;
  deskprofileError: boolean = false;
  errorStatus: number;
  desks: Array<object>;
  offices: Array<object>;
  autoLogin: boolean = false;
  numLoaded: number = 0;
  desk: any = null;
  showSelectOffice: boolean = true;
  office: number = null;
  officename: string = "";
  token: string = null;
  private subscriptionClose: Subscription;
  private subscriptionOpen: Subscription;
  private config = null;
  private loadingSocket: boolean = false;

  public changePasswordForm: FormGroup;
  public repeatPasswordAlert: boolean = false;
  public repeatPasswordAlertText: string = "";
  public repeatPasswordAlertClass: string = "alert-success";

  lastCredentials: object = {};
  onlineDeskName: string = "";
  onlineOfficeName: string = "";
  onlineDeskIP: string = "";
  disconectSessionConfirm: boolean = false;

  private destroy$ = new Subject();

  constructor(
    private _lf: FormBuilder,
    private _blogic: BusinesLogicService,
    private _data: DataService,
    private _language: LanguageService,
    private _notify: NotificationService,
    private _modal: ModalHelper,
    private _lang: LanguagePipe,
    private _http: HttpClient,
    private _bevent: BusinessEventService,
  ) {
    this._getOffices();
    if (this._data.isLogged()) {
      this.autoLogin = true;
    }

    let lang: any = navigator.language;
    if (lang.length > 2) {
      lang = lang.split("-");
      lang = lang[1];
    }
    this._language.exist(lang.toUpperCase());

    let desk = localStorage.getItem("desk");
    let office = localStorage.getItem("office");
    if (desk != null) {
      this.desk = JSON.parse(desk);
      let coffice = JSON.parse(office);
      if (coffice != null) {
        this.office = parseInt(coffice["id"]);
        this.officename = coffice["name"];
      }
    }
  }

  public ngOnInit(): void {
    if (this.visible) {
      this.loadFormInputs();

      this.getJSON()
        .pipe(takeUntil(this.destroy$))
        .subscribe((data: DeskConfig) => {
          this.config = data;
          this._data.json_config = data;
          if (data.autologin && data.autologin.active) {
            let credentials: object = {
              username: data.autologin.username,
              pwd: data.autologin.password,
              desk_id: parseInt(data.autologin.desk_id.toString()),
            };
            this.office = data.autologin.office_id;
            this.doLogin(credentials);
          } else {
            if (this._data.isLogged()) {
              let credentials: object = this._data.getStoredCredentials();
              this.doLogin(credentials);
            }
          }

          if (this.office) {
            this._getDesks(this.office, false);
          }

          if (this.config.autoreset) {
            localStorage.removeItem("office");
            localStorage.removeItem("desk");
            this.desk = null;
            this.loadFormInputs();
          }
        });
    }

    this._blogic.loginError$
      .pipe(takeUntil(this.destroy$))
      .subscribe((response) => {
        if (response != false) {
          this.errorStatus = response["status"];
          this.autoLogin = false;
          this.hasError = true;
          this.deskprofileError = false;
          this._data.deleteStoredCredentials();
        }
      });

    this.initChangePasswordForm();
  }

  private _findGetParameter(parameterName) {
      var result = null,
          tmp = [];
      var items = location.search.substr(1).split("&");
      for (var index = 0; index < items.length; index++) {
          tmp = items[index].split("=");
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
      }
      return result;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public initChangePasswordForm() {
    this.changePasswordForm = new FormGroup({
      user: new FormControl("", [Validators.required]),
      lastPassword: new FormControl(""),
      newPassword: new FormControl("", [Validators.required]),
      repeatNewPassword: new FormControl("", [Validators.required]),
    });
  }

  public loadFormInputs() {
    if (localStorage.getItem("desk") == null) {
      this.loginForm = this._lf.group({
        desk: ["", Validators.required],
        user: ["", Validators.required],
        password: [""],
      });
    } else {
      this.loginForm = this._lf.group({
        user: ["", Validators.required],
        password: [""],
      });
    }
  }

  public getJSON(): Observable<any> {
    return this._http.get("./assets/config.json");
  }

  /* Action of submit button */
  public onSubmit(): void {
    switch (this.loginForm.get("user").value) {
      case "resetall":
        this.removeOffice();
        break;
      case "reset":
        this.removeDesk();
        break;
      default:
        if (this.loginForm.get("user").value == "reset") {
          this.removeOffice();
        } else {
          let desk: string;
          if (localStorage.getItem("desk") == null) {
            desk = this.loginForm.get("desk").value;
          } else {
            desk = JSON.parse(localStorage.getItem("desk")).id;
          }
          let user: string = this.loginForm.get("user").value;
          let password: string = this.loginForm.get("password").value;

          let credentials: object = {
            username: user,
            pwd: password,
            desk_id: parseInt(desk),
          };

          this.doLogin(credentials);
        }
        break;
    }
  }

  public isLoginAvailable(credentials: object): Promise<object> {
    return new Promise((resolve) => {
      let params = {
        desk_id: credentials["desk_id"],
      };

      this._blogic
        .checkDeskOnline(params)
        .pipe(takeUntil(this.destroy$))
        .subscribe((response: any) => {
          resolve(response);
        });
    });
  }

  /* Do login with credentials object */
  async doLogin(
    credentials: object,
    withOnlineFilter: boolean = true,
    link: boolean = false
  ) {
    if (withOnlineFilter) {
      var deskStatus: object = {};
      await this.isLoginAvailable(credentials).then((value) => {
        deskStatus = value;
      });
      let isDeskOnline: boolean = deskStatus["hostaddr"] == null ? false : true;

      if (isDeskOnline === true) {
        this.lastCredentials = credentials;
        this.onlineDeskName = deskStatus["desk_name"];
        this.onlineOfficeName = deskStatus["office"];
        this.onlineDeskIP = deskStatus["hostaddr"];
        this.showDeskInUse();
        return false;
      }
    } else {
      this._modal.hide("deskInUseModal");
    }

    this._blogic
      .token(credentials)
      .pipe(takeUntil(this.destroy$))
      .subscribe((response1: any) => {
        this.token = response1.access_token;
        this._data.token = this.token;

        this.deskprofileError = false;

        this._blogic
          .login(credentials)
          .pipe(takeUntil(this.destroy$))
          .subscribe(
            (response2: any) => {
              if (response2 == null) {
                this.deskprofileError = true;
                this.hasError = false;
              } else {
                this.deskprofileError = false;
              }

              let desk = credentials["desk_id"];
              let user = credentials["username"];
              this._data.session = response2;

              let deskSaved = JSON.parse(localStorage.getItem("desk"));
              let officeSaved = JSON.parse(localStorage.getItem("office"));

              var deskData = this._getDeskById(this._data.desks, desk);

              if (!withOnlineFilter) {
                window.location.reload();
              }

              if (deskData == null || typeof deskData == "undefined") {
                setTimeout(() => {
                  this.doLogin(credentials, withOnlineFilter, link);
                }, 500);
                return;
              }

              if (deskSaved == null) {
                this._data.session["desk"] = desk;
                let coffice = this._getOfficeById(this.offices, this.office);
                this._data.session["deskname"] = deskData.title;
                this._data.session["office"] = this.office;
                this._data.session["officename"] = coffice.name;
              } else {
                this._data.session["desk"] = deskSaved.id;
                this._data.session["deskname"] = deskSaved.name;
                this._data.session["qdesk_id"] = deskSaved.qdesk_id;
                this._data.session["office"] = officeSaved.id;
                this._data.session["officename"] = officeSaved.name;
              }

              let deskObj = {
                id: this._data.session["desk"],
                name: this._data.session["deskname"],
              };

              let officeObj = {
                id: this._data.session["office"],
                name: this._data.session["officename"],
              };

              this._data.session["qdesk_id"] = deskData.qdesk_id;

              localStorage.setItem("desk", JSON.stringify(deskObj));
              localStorage.setItem("office", JSON.stringify(officeObj));

              this._data.session["operator"] = user;

              this._getOfficeConfiguration();

              this._notify.getPermissions();
              this._getDeskStatus();
              this._getAtypes();
              if (this._data.session["deskconfig"] != null) {
                this._data.configuration = JSON.parse(
                  this._data.session["deskconfig"]
                );
                this._language.exist(this._data.configuration["language"]);
              }
              this._getSessionId(this._data.session["desk"]);
              // Initialize socket
              this.InitSocketCom();
              this._data.storeCredentials(credentials);
              this.hasError = false;
              if (link) {
                window.location.reload();
              }
            },
            (err) => {
              console.log("Entro en error");
              console.log(err);
            }
          );
      });
  }

  private _getOfficeConfiguration() {
    this._blogic.configDesk()
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: any) => {
        this._data.dniTranslation = (response.translations_dni && response.translations_dni.length > 0) ? response.translations_dni	: "DNI del cliente";
        this._data.ccodeTranslation = (response.translations_ccode && response.translations_ccode.length > 0) ? response.translations_ccode	: "Código del cliente";
      });
  }

  public showDeskInUse(): void {
    this.disconectSessionConfirm = false;
    this._modal.show("deskInUseModal");

    let self = this;

    $("#deskInUseModal").on("hidden.bs.modal", function (e) {
      self.resetLogin();
    });
  }

  resetLogin(): void {
    this._modal.hide("deskInUseModal");
    this.autoLogin = false;
    this.hasError = true;
    this.deskprofileError = false;
    this._data.deleteStoredCredentials();
    localStorage.removeItem("office");
    localStorage.removeItem("desk");
    this.desk = null;
    this.loadFormInputs();
  }

  private InitSocketCom() {
    if (!this.loadingSocket) {
      this.loadingSocket = true;
      if (this.subscriptionClose != null) this.subscriptionClose.unsubscribe();
      if (this.subscriptionOpen != null) this.subscriptionOpen.unsubscribe();
      this._bevent.close();

      this._bevent.open();

      this.subscriptionOpen = this._bevent
        .onOpen()
        .subscribe((response: any) => {
          this.loadingSocket = false;
        });

      this.subscriptionClose = this._bevent
        .onClose()
        .subscribe((response: any) => {
          this._bevent.close();
          this.InitSocketCom();
          this.loadingSocket = false;
        });
    }
  }

  /* Get the actual session id */
  private _getSessionId(desk: number): void {
    let params: object = {
      op: "status",
      desk_id: desk,
    };

    this._blogic
      .getSession()
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: any) => {
        this._data.session["session"] = response[0]["id"];
        this._sumLogged();
      });
  }

  /* Get the offices list */
  private _getOffices(): void {
    this._blogic
      .getOffices()
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: any) => {
        this.offices = response;
        this._data.offices = response;
      });
  }

  /* Get Office from list of desk using id */
  private _getOfficeById(data: any, office_id: any) {
    for (let i = 0; i < data.length; i++) {
      if (data[i].id == office_id) return data[i];
    }
  }

  /* Get the office's desk list*/
  private _getDesks(id: number, setvalue: boolean = true): void {
    this._blogic
      .listDesk({ office_id: this.office })
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: any) => {
        this.desks = response.filter((e) => e.visible == true);
        if (response.length != 0 && setvalue)
          this.loginForm.controls["desk"].setValue(this.desks[0]["id"]);
        this._data.desks = this.desks;
      });
  }

  /* Get the actual desk status */
  private _getDeskStatus(): void {
    let params: object = {
      desk_id: this._data.session["desk"],
      status: "query",
    };

    this._blogic
      .deskNotify(params)
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: any) => {
        let turn = response;
        if (turn["id"] != -1) {
          this._data.turn = turn;
        }
        this._sumLogged();
      });
  }

  /* Get Desk from list of desk using id */
  private _getDeskById(data: any, desk_id: any) {
    for (let i = 0; i < data.length; i++) {
      if (data[i].id == desk_id) return data[i];
    }
  }

  /* Parse desk list using the desk id as key of array */
  private _parseDesk(data: any): any[] {
    let parseArray: any[] = [];
    for (let i = 0; i < data.details.length; i++) {
      parseArray[data.details[i].id - 1] = data.details[i];
    }
    return parseArray;
  }

  /* Get the desk list */
  private _getAtypes(): void {
    this._blogic
      .kindListOffice()
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: any) => {
        this._data.session["atypes"] = this._parseAtypes(response);
        this._sumLogged();
      });
  }

  /* Parse atype list using the desk id as key of array */
  private _parseAtypes(data: any): any[] {
    this._data.session["allTypes"] = data;
    var filterArray: any[] = [];
    if (this._data.session["changekind"].length != 0) {
      var availableAtypes: any[] = this._data.session["changekind"].split(",");

      for (let i = 0; i < data.length; i++) {
        if (availableAtypes.indexOf(data[i].id.toString()) != -1) {
          filterArray.push(data[i]);
        }
      }
      return filterArray;
    }
    return data;
  }

  private _sumLogged(): any {
    this.numLoaded = this.numLoaded + 1;
    /* No turn */
    if (this.numLoaded == 3) {
      this.autoLogin = true;
      this.logged.emit(this.autoLogin);
      this._data.session["desks"] = this.desks;
    }
  }

  public removeOffice() {
    localStorage.removeItem("office");
    localStorage.removeItem("desk");
    this.desk = null;
    this.showSelectOffice = true;
    this.ngOnInit();
  }

  public removeDesk() {
    localStorage.removeItem("desk");
    this.desk = null;
    if (localStorage.getItem("office") != null) this.showSelectOffice = false;
    this.ngOnInit();
  }

  public changeOffice() {
    this._getDesks(this.office);
  }

  public openChangePasswordModal() {
    this.initChangePasswordForm();
    this.repeatPasswordAlert = false;
    this._modal.show("changePasswordModal");
  }

  public showAlert(cssClass, text) {
    this.repeatPasswordAlertClass = cssClass;
    this.repeatPasswordAlertText = text;
    this.repeatPasswordAlert = true;
  }

  public changePassword() {
    if (
      this.changePasswordForm.get("newPassword").value !=
      this.changePasswordForm.get("repeatNewPassword").value
    ) {
      this.showAlert(
        "alert alert-danger",
        this._lang.transform("passwordNotMatch")
      );
      this.changePasswordForm.controls["repeatNewPassword"].setErrors({
        incorrect: true,
      });
    } else {
      let params = {
        login: this.changePasswordForm.get("user").value,
        oldpwd: this.changePasswordForm.get("lastPassword").value,
        newpwd: this.changePasswordForm.get("newPassword").value,
      };

      this._blogic
        .changePassword(params)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (response) => {
            this.showAlert(
              "alert alert-success",
              this._lang.transform("passwordSuccess")
            );
            setTimeout(() => {
              this._modal.hide("changePasswordModal");
            }, 1500);
          },
          (error) => {
            this.showAlert(
              "alert alert-danger",
              this._lang.transform("invalidUserPassword")
            );
            this.changePasswordForm.controls["user"].setErrors({
              incorrect: true,
            });
            this.changePasswordForm.controls["lastPassword"].setErrors({
              incorrect: true,
            });
          }
        );
    }
  }
}
